export default __webpack_public_path__ + "static/media/profile-picture.5b4760c9.jpg";